<template>
  <div class="col-md-5 mr-3 mt-3 basics-10-bg" style="border: 1px solid rgba(0,0,0,.1);">
    <h5 class="text-center pt-3">
      Accéder à mon espace personnel
    </h5>
    <hr class="ml-3 mr-3">
      
    <div v-if="!showForm">        
      <div class="row justify-content-center">
        <div class="col ml-3 mr-3 text-center">
          <div class="text text-center">
            FranceConnect est la solution proposée par l’État pour sécuriser et simplifier la connexion à vos services en ligne
          </div>
          <br>
          <div class="d-flex flex-column align-items-center">
            <button 
              class="btn fc-button p-0" 
              style="height:56px; width:209px" 
              @click="init()"
            />
            <a 
              class="btn btn-link-primary text-sm" 
              style="margin-top: 8px;" 
              href="https://franceconnect.gouv.fr/" 
              target="_blank"
            >
              Qu'est-ce que FranceConnect ?
            </a>
          </div>
          <small v-if="errorMessage" class="text-danger">
            <label>{{ errorMessage }}</label>
          </small>
        </div>
      </div>
  
      <div class="row mt-3">
        <div class="col ml-3">
          <hr>
        </div>
        <div class="col-auto text-sm font-weight-bold p-0">
          Ou
        </div>
        <div class="col mr-3">
          <hr>
        </div>
      </div>
  
      <!-- Alternative connection -->
      <div class="row justify-content-center">
        <div class="justify-content-center">
          <button 
            class="btn btn-link-primary" 
            @click="showForm = true"
          >
            Je n’ai pas FranceConnect
          </button>
        </div>
      </div>
    </div>
  
    <div v-else>
      <div class="d-flex row">
        <div class="col ml-3 mr-3 text-center">
          <button 
            class="btn btn-link-primary d-flex align-items-center mb-4" 
            @click="showForm = false"
          >
            <icon-arrow-left class="mr-1" />Me connecter avec FranceConnect
          </button>
          <div class="d-flex row justify-content-center">
            <form class="form large-input">
              <div class="d-flex mb-3 flex-wrap">
                <div class="d-flex flex-column col-md-6 w-100 mb-2">
                  <label class="label">Nom</label>
                  <input v-model="form.family_name" class="input w-100" type="text">
                </div>
                <div class="d-flex flex-column col-md-6 w-100 mb-2">
                  <label class="label">Prénom</label>
                  <input v-model="form.given_name" class="input w-100" type="text">
                </div>
              </div>
  
              <div class="d-flex mb-3 flex-wrap">
                <div class="d-flex flex-column col-md-6 w-100 mb-2">
                  <label class="label">Date de naissance</label>
                  <input v-model="form.birthdate" class="input w-100" type="date">
                </div>
                <div class="d-flex flex-column col-md-6 w-100 mb-2">
                  <label class="label">Sexe</label>
                  <select v-model="form.gender" class="input w-100">
                    <option value="male" selected>
                      Homme
                    </option>
                    <option value="female">
                      Femme
                    </option>
                    <option value="other">
                      Autre
                    </option>
                  </select>
                </div>
              </div>
  
              <div class="d-flex mb-3 mx-3 flex-wrap">
                <div class="d-flex flex-column w-100 mb-2">
                  <label class="label">Mot de passe</label>
                  <div class="d-flex align-items-center position-relative w-100">
                    <input
                      v-model="form.password"
                      :type="showPassword ? 'text' : 'password'"
                      class="w-100 input"
                    >
                    <button
                      class="btn btn-link-primary password position-absolute"
                      style="right: 2px; top: 50%; transform: translateY(-50%);"
                      @click.prevent="toggleShowPassword"
                    >
                      <icon-eye-open v-if="showPassword" />
                      <icon-eye-close v-else />
                    </button>
                  </div>
                </div>
              </div>
  
              <div class="d-flex mb-2 mx-3 align-items-start">
                <span class="d-inline-flex my-auto text-caption border rounded py-1 px-2 font-demi-bold warning-surface-bg b-warning-border warning-pressed align-items-center">
                  <icon-warning />
                </span>
                <span class="text-caption ml-1 basics-80" style="text-align: left;">
                  {{ HELP_MESSAGE }}
                </span>
              </div>
              <div class="d-flex mb-1 mx-3 text-center">
                <small class="text-danger">
                  <label>{{ errorMsg }}</label>
                </small>
              </div>
              <button class="btn btn-primary" @click.prevent="validate()">
                Valider
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>

import AuthService from '../../services/auth.service';
import { LOG_AUTH_CODES, GENERIC_MESSAGE, HELP_MESSAGE } from '../../enums/logAuthEnum.js';
import IconArrowLeft from '../../assets/icons/IconArrowLeft.vue';
import IconWarning from '../../assets/icons/IconWarning.vue';
import IconEyeClose from '../../assets/icons/IconEyeClose.vue';
import IconEyeOpen from '../../assets/icons/IconEyeOpen.vue';
import moment from 'moment';
export default {
  name: 'ConnectionChoice',
  components: { IconArrowLeft, IconWarning, IconEyeClose, IconEyeOpen },
  data() {
      return {
          errorMsg: '',
          showForm: false,
          form: {
            given_name: "",
            family_name: "",
            birthdate: "",
            gender: "male",
            password: ""
          },

          showPassword: false,
          HELP_MESSAGE
      };
  },

  computed: {
      errorMessage() {
        let error = sessionStorage.getItem("error");
        let entry = null;
        if (error) {
          entry = Object.values(LOG_AUTH_CODES).find(item => item.code === error);
          return entry ? entry.message : GENERIC_MESSAGE;
        }
        return null;
      },
  },

  mounted(){
    if(this.$route.query && this.$route.query.error && this.$route.query.state) {
      sessionStorage.setItem("error", this.$route.query.error);
    } 
  },

  destroyed() {
    this.error_msg = null;
    sessionStorage.removeItem("error");
    this.errorMessage = null;
  },

  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },

    init() {
        AuthService.init().then(url => {
            window.location.href = url;
        });
        sessionStorage.removeItem("error");
      },

      sendForm(){
        this.form.birthdate = moment(this.form.birthdate).format("YYYY-MM-DD");
        AuthService.form(this.form).then((response) => {
            if(response.access_token && response.id_token) {
                this.$router.push({ name: 'Profil' });
            }
        }).catch(error => {
            var err = Object.values(LOG_AUTH_CODES).find(item => error.response.data[item.code]);
            this.errorMsg = err ? err.message : GENERIC_MESSAGE;
        });
      },

      validate(){
        if(this.form.given_name.length > 0 && this.form.family_name.length > 0 && this.form.birthdate.length > 0 && this.form.password.length > 0 && this.form.gender.length > 0){ 
            this.sendForm();
        } else {
            this.errorMsg = "Veuillez remplir tous les champs";
        }

    }
  },
};
</script>

<style scoped>
.subtitle {
    font-family: Avenir Next;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: -0.4000000059604645px;
    text-align: left;
}

li, .text {
    font-family: Avenir Next;
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: -0.30000001192092896px;
    text-align: left;
    color:#4B535E
}

.large-input .input {
  height: 35px;
}

</style>
